var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-overlay',{attrs:{"show":_vm.busy}},[_c('b-container',{staticClass:"data-entry"},[_c('h2',[_vm._v("Create new user")]),_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_c('user-form',{on:{"save":_vm.createUser}})],1)])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }